import {useEffect,useState} from "react";
import axios from "axios";

import API_URL from "../config/config";
import AdminSidebar from "../components/AdminSidebar";
import "../css/admin.css";

import {
FaTrash,
FaUsers
} from "react-icons/fa";


function AdminUsers(){


const [users,setUsers]=useState([]);

const [search,setSearch]=useState("");



useEffect(()=>{

loadUsers();

},[]);



const loadUsers = () => {

    axios.get(`${API_URL}/admin/users`, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
        }
    })
    .then((res) => {

        setUsers(res.data);

    })
    .catch((err) => {

        console.log(err);

    });

};





const deleteUser=(id)=>{


if(!window.confirm("Delete this user?"))
return;

axios.delete(
    `${API_URL}/admin/users/${id}`,
    {
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
        }
    }
)
.then(()=>{

alert("User Deleted");

loadUsers();

});


};




return(

<div className="admin-layout">


<AdminSidebar />


<div className="admin-content">


<h1>
<FaUsers/> Users
</h1>


<input

className="admin-search"

placeholder="Search user..."

value={search}

onChange={(e)=>setSearch(e.target.value)}

/>



<table className="admin-table">


<thead>

<tr>

<th>ID</th>

<th>Name</th>

<th>Email</th>

<th>Phone</th>

<th>Role</th>

<th>Action</th>


</tr>

</thead>


<tbody>


{

users

.filter(user=>

user.email
.toLowerCase()
.includes(search.toLowerCase())

)

.map(user=>(


<tr key={user.id}>


<td>
{user.id}
</td>


<td>
{user.first_name} {user.last_name}
</td>


<td>
{user.email}
</td>


<td>
{user.phone}
</td>


<td>
{user.role || "user"}
</td>


<td>


<button

className="delete-btn"

onClick={()=>deleteUser(user.id)}

>

<FaTrash/>

Delete

</button>


</td>


</tr>


))


}


</tbody>


</table>


</div>


</div>


);


}


export default AdminUsers;